import 'jquery-placeholder';
import BaseView from '../core/baseView';
import { reload } from '../validation/validation-controller';
import * as lightbox from '../../home24/helpers/lightbox';

export default BaseView.extend({
  events: {
    'click .footer-subscribe__gift-label': 'onNewsletterLinkClick'
  },

  initialize: function() {
    this.$('.newsletter-input').placeholder();

    if (window.location.hash === '#newsletter') {
      this.showLightbox();
    }
  },

  onNewsletterLinkClick: function(event) {
    event.preventDefault();
    this.showLightbox();
  },

  showLightbox: function() {
    lightbox
      .setConfig({
        $dialog: this.$('.newsletter'),
        className: 'newsletter'
      })
      .open();

    reload();
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/newsletterView.js
 **/